import "./_style.css"
import BreadCrumbs from "../../components/BreadCrumbs";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import Footer from "../../components/Footer";
import {useParams} from "react-router-dom";
import StatItem from "./StatItem"
import PieDiagram from "./PieDiagram";


export default function ProjectDetails() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    const {prjid} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../projects/1'},
        {'name': 'Project stats', 'link': ''}
    ]

    const [feedObj, setFeedObj] = useState<any>({
        feedName: '',
        srcTaxName: '',
        srcTaxID: 0,
        trgTaxName: '',
        trgTaxID: 0,
        brandsList: [],
        localesList: [],
        prodsNum: 0,
        firstRun: '',
        lastRun: '',
        srcCatFeatsStats: {},
        srcCatsStats: {},
        familiesNum: 0,
        icecatManager: '',
        icecatPM: '',
        reportEmails: {icecat: [], client: []},
        dataFormat: '',
        accessType: '',
        runMode: '',
        accessCredentials: '',
        feedNotes: ''
    })

    // let accessDataPieces = []
    // try {
    //     for (let item in feedObj.accessCredentials) {
    //         accessDataPieces.push(item + ': ' + feedObj.accessCredentials[item])
    //     }
    // } catch (err) {}
    // let accessDataString = accessDataPieces.length > 0 ? accessDataPieces.join('\n') : ''


    useEffect(() => {
        getProjStats()
    }, [])

    let getProjStats = async () => {
        let response = await fetch(`${serverIP}/getprojstats/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid}),
        })
        let data = await response.json()

        if (response.status === 200) {
            setFeedObj(data)

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    // UPDATING HERE
    useEffect(() => {
        if (feedObj.feedName !== "") {
            updFeedObj()
        }
    }, [feedObj])

    let updFeedObj = async () => {
        let response = await fetch(`${serverIP}/updfeedobj/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(feedObj),
        })
        let data = await response.json()

        if (response.status === 200) {

            // console.log('data has been saved')

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <div className="prj-details-container">

                {/* PROJECT TYPE */}

                <div className="one-block">
                    <StatItem editable={false} setObj={null} label={"Project type"} text={"Import"} />
                    <StatItem editable={false} setObj={null} label={"Source taxonomy"} text={feedObj.srcTaxName} />
                    <StatItem editable={false} setObj={null} label={"Source tax ID: "} text={feedObj.srcTaxID} />
                    <StatItem editable={false} setObj={null} label={"Target taxonomy"} text={feedObj.trgTaxName} />
                    <StatItem editable={false} setObj={null} label={"Target tax ID: "} text={feedObj.trgTaxID} />
                    <StatItem editable={false} setObj={null} label={"Brands"} text={feedObj.brandsList.join(", ")} />
                    <StatItem editable={false} setObj={null} label={"Locales"} text={feedObj.localesList.join(", ")} />
                    <StatItem editable={false} setObj={null} label={"Products qty"} text={feedObj.prodsNum} />
                </div>


                <div className="one-block">

                    <div className="piechart-grid">
                        <div className="one-pie">
                            <PieDiagram mappedPercent={feedObj?.srcCatsStats?.coverage} />
                            <div className="pie-label">mapped categories</div>
                        </div>
                        <div className="one-pie">
                            <PieDiagram mappedPercent={feedObj?.srcCatFeatsStats?.coverage} />
                            <div className="pie-label">mapped features</div>
                        </div>
                    </div>

                </div>


                <div className="one-block item-merged">
                    <StatItem editable={false} setObj={null} label={"Launch date"} text={feedObj.firstRun} />
                    <StatItem editable={false} setObj={null} label={"Last run"} text={feedObj.lastRun} />
                    <StatItem editable={false} setObj={null} label={"Categories qty"} text={feedObj.srcCatsStats?.total} />
                    <StatItem editable={false} setObj={null} label={"Category-Features"} text={feedObj.srcCatFeatsStats?.total} />
                    <StatItem editable={false} setObj={null} label={"Families qty"} text={feedObj.familiesNum} />

                    {/*editable fields*/}
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Icecat Manager"} text={feedObj.icecatManager} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Icecat PM"} text={feedObj.icecatPM} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Icecat report emails"} text={feedObj.reportEmails.icecat.join(", ")} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Client report emails"} text={feedObj.reportEmails.client.join(", ")} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Feed data format"} text={feedObj.dataFormat} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Feed access type"} text={feedObj.accessType} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Feed access data"} text={feedObj.accessCredentials} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Run mode"} text={feedObj.runMode} />
                    <StatItem editable={userPermissions.canEdit} setObj={setFeedObj} label={"Notes"} text={feedObj.feedNotes} />

                </div>




                {/*<div className="prj-details-sub">*/}
                {/*    <div>Source taxonomy:</div>*/}
                {/*    <div>Icecat</div>*/}
                {/*</div>*/}
                {/*<div className="prj-details-sub">*/}
                {/*    <div>Source taxonomy last update:</div>*/}
                {/*    <div>2023-04-01</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Target taxonomy:</div>*/}
                {/*    <div>BOL (JSON schema)</div>*/}
                {/*</div>*/}


                {/*<div className="prj-details-sub">*/}
                {/*    <div>Target taxonomy taxonomy source:</div>*/}
                {/*    <div>https://api.bol.com/retailer/public/Retailer-API/index.html</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Target taxonomy locales (countries):</div>*/}
                {/*    <div>NL, BE</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Target taxonomy last update:</div>*/}
                {/*    <div>2023-02-12</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Project management:</div>*/}
                {/*    <div>Rene Rozendal, Martijn Zey, Sviat Sydorchenko</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Coverage categories mapping:</div>*/}
                {/*    <div>2%</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Coverage category-feature mapping:</div>*/}
                {/*    <div>1%</div>*/}
                {/*</div>*/}


                {/*<div className="prj-details-sub">*/}
                {/*    <div>Number of products pushed:</div>*/}
                {/*    <div>190</div>*/}
                {/*</div>*/}

                {/*<div className="prj-details-sub">*/}
                {/*    <div>Last time products pushed:</div>*/}
                {/*    <div>2023-02-02 14:36:01</div>*/}
                {/*</div>*/}

            </div>


            <Footer />
        </>
    )

}